<script setup lang="ts">
import { computed, watch } from 'vue'
import TopNavPrimary from "@/views/nav/top-nav-primary.vue";
import TopNavSecondary from "@/views/nav/top-nav-secondary.vue";
import { useRoute } from "vue-router";
import { useAuthenticatedUser } from '@/shared/composables/useAuthenticatedUser'

const props = defineProps<{ showSecondary?: boolean }>()
const route = useRoute()
const { data: authenticatedUser } = useAuthenticatedUser(() => route.matched.length > 0 && route.meta.requiresAuth !== false)

const showSecondary = computed(() => authenticatedUser.value !== undefined && props.showSecondary)
</script>

<template>
  <div :class="$style.container">
    <TopNavPrimary />
    <TopNavSecondary v-if="showSecondary" />
  </div>
</template>

<style module lang="scss">
.container {
  z-index: 5;
  position: sticky;
  top: 0;
}
</style>
